import Alert from '@ui/Alert/component'

export default function () {
  const alertEl = document.getElementById('mosaik-return-alert') as HTMLElement

  alertEl && Alert(alertEl)
}
